module.exports = require('@gik/core/tailwind.config.js')

